import store from '@/store'

const mixins = {
  computed: {
    $authUser: () => store.getters['auth/authUser'],
    $loggedIn: () => store.getters['auth/loggedIn'],
    $superAdmin: () => store.getters['auth/superAdmin'],
    $formRules: () => {
      return {
        required: v => !!v || 'This field is required.',
        email: v => /.+@.+\..+/.test(v) || 'Must be a valid email.'
      }
    }
  },
  methods: {
    $can: function(permissions) {
      if (this.$superAdmin) {
        return true
      } else if (this.$loggedIn) {
        const assignedPermissions = this.$authUser.permissions

        if (typeof permissions === 'string') {
          return assignedPermissions.includes(permissions)
        } else {
          return (
            permissions.find(
              permission => !assignedPermissions.includes(permission)
            ) === undefined
          )
        }
      } else {
        return false
      }
    }
  }
}

export default mixins
